import { render, staticRenderFns } from "./alreadyCancel.vue?vue&type=template&id=2132cac6&scoped=true&"
import script from "./alreadyCancel.vue?vue&type=script&lang=js&"
export * from "./alreadyCancel.vue?vue&type=script&lang=js&"
import style0 from "./alreadyCancel.vue?vue&type=style&index=0&id=2132cac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132cac6",
  null
  
)

export default component.exports